module.exports = __webpack_public_path__ + "39d3db1368097ff16ccc8a18576eb9e8.svg";